import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Alert } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TopNav from "../../components/Common/TopNav";
import AnalyticsWidgets from "./AnalyticsWidgets";
import BrushChart from "./BrushChart";
import { toPng } from 'html-to-image';
//redux
import { useSelector } from "react-redux";
import { RootState } from "../../slices/store";
import "./analytics.css"

const Analytics = () => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const userState = useSelector((state: RootState) => state.login.user.user);
  const [showAlert, setShowAlert] = useState(false);
  const adminUser: any = localStorage.getItem("adminUser");
  const tempAuthUser: any = localStorage.getItem("tempAuthUser");
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    if ((userState && userState.name) && (adminUser || tempAuthUser)) {
      const alertShownKey = 'alert_shown';
      const hasShownAlert = localStorage.getItem(alertShownKey);
      if (!hasShownAlert) {
        setShowAlert(true);
        localStorage.setItem(alertShownKey, 'true');
      }
    }
  }, [userState]);
  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showAlert]);

  const captureWidgetAsImage = async () => {
    if (widgetRef.current) {
      try {
        await new Promise((resolve) => setTimeout(resolve, 100));
        const imgData = await toPng(widgetRef.current, { cacheBust: true, useCORS: true });
        return imgData;
      } catch (error) {
        console.error("Error capturing widget image:", error);
        return null;
      }
    }
    return null;
  };

  return (
    <React.Fragment>
      <Container fluid style={{ maxWidth: "100%" }}>
        <div className="page-content" style={{ paddingTop: "0" }}>
          <div className="mobile-breadcrumbs-section">
            <Breadcrumbs title="Dashboard" breadcrumbItem="Analytics" titleLink="/analytics" />
          </div>
          {showAlert && (
            <Alert
              color="primary"
              className="uncontrolled-alert"
            >
              <i className="uil uil-user-circle me-2"></i>
              {`You are logged in using ${userState?.name}`}
            </Alert>
          )}
          <div className="widget_box chartsjoy" ref={widgetRef}>
            <AnalyticsWidgets setNoData={setNoData} />
            <Row>
              <BrushChart />
            </Row>

          </div>

        </div>

        {/* Responsive Styles */}
        <style>
          {`
          @media (max-width: 768px) {
            .main-navbar {
              padding: 5px;
            }
            .topnav-filters {
              top: 50px; /* Adjust based on your main navbar height */
              padding: 5px;
            }
            .page-content {
              margin-top: 10px !important;
            }
            .container-fluid {
              padding-left: 10px;
              padding-right: 10px;
            }
           
            .col {
              padding-left: 5px;
              padding-right: 5px;
            }
          }
        `}
        </style>
      </Container>
    </React.Fragment>
  );
};

export default Analytics;
